import Mustache from 'mustache'
export default class FlattenedHash {

    constructor(obj, key, postfilters) {
        key = key ? key : 'Result'
        this.Result = this.PostFilter(this.TheLoop(obj, key), postfilters)
    }

    PostFilter(obj, filters) {
        const origObj = { ...obj }
        if (!filters) return obj
        for (var k of Object.keys(filters))
            if (Object.keys(obj).includes(k))
                obj[k] = filters[k](obj[k], origObj)
        return obj
    }

    TheLoop(props, parent) {
        var res = {}

        if (Array.isArray(props)) {
            for (const o of props) {
                res = { ...res, ...this.TheLoop(o, parent) }
            }
        }
        else if (typeof props === 'object')
            for (const o of Object.keys(props)) {
                if (o === 'receivedFrom') {
                    if (Array.isArray(props[o]) && isNaN(Object.keys(props[o][0]))) {
                        res = {
                            ...res,
                            ...{ [parent + '|receivedFrom']: props[o].join(',') }
                        }
                    } else {
                        res = {
                            ...res,
                            ...{ [parent + '|receivedFrom']: Object.keys(props[o]).join(',') }
                        }
                    }
                } else
                    res = { ...res, ...this.TheLoop(props[o], parent + '|' + o) }
            }
        else {
            res[parent] = props
        }
        return res;
    }

    GetResult() {
        return this.Result;
    }

    GetValue(key) {
        return Object.keys(this.Result).includes(key) ? this.Result[key] : 'Unknown';
    }

    FromMustache(mustache) {
        return Mustache.render(mustache.replace(/\t|\n\s*|\r|\t/g, ""), this.Result)
    }
}